/**
 * @file UpperScrollbar
 */

'use strict';
import Common from '../../Utils/Common';

/**
 * @classname UpperScrollbar
 * @classdesc UpperScrollbar
 */
export default class UpperScrollbar {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log(`UpperScrollbar.constructor`);
		this._$table = $('.table-scroll-box table');
		$('.table-scrollbar, .table-scroll-box').on('scroll', function () {
			if ($(this).hasClass('table-scrollbar')) {
				//scrollLeftでスクロール量を取得
				$('.table-scroll-box').scrollLeft($(this).scrollLeft());
			} else {
				$('.table-scrollbar').scrollLeft($(this).scrollLeft());
			}
		});
		$('#show-info').on('change', () => this.setInnerWidth());
		this.setInnerWidth();
	};


	/**
	 * テーブル幅取得
	 *
	 * @memberof UpperScrollbar
	 * @return {undefined}
	 */
	setInnerWidth() {
		console.log(`UpperScrollbar.setInnerWidth`);
		const width = this._$table.outerWidth();
		setTimeout(() => {
			$('.table-scrollbar .inner').css('width', `${width}px`);
		}, 100);
	}
}
